import {booleanSchema, IS_REQUIRED_CODE, RecordSchema, recordSchema, stringSchema} from '@lightweightform/storage';

import {convertDatesAtPathsJs2Json, convertDatesAtPathsJson2Js, sharedSchemas} from '../../shared';
import {pt} from 'oss-registo-kotlin-common-js';

const {bankAccountInfoSchema, makeRegistrationSchema, vatIdSchema, fixedEstablishmentsSchema, OssSchemaType, getInitialValues, registeredByNetp} = sharedSchemas;

const {
  CustomErrorCodes
} = pt.at.oss.kotlin.manual.enumeration;

const {
  IDENTIFICATION_OF_BUSINESS_VAT_ID_VALIDATOR,
  IdentOfBusinessValidator,
} = pt.at.oss.kotlin.manual.validator.common;

/**
 * Date conversion functions
 **/
const IMPORT_DATES_PATHS = [
  ['relevantDates', 'registrationReqDate'],
  ['relevantDates', 'forecastStartDate'],
  ['relevantDates', 'msidDecisionDate'],
];
export function convertDatesImportJson2Js(importForm) {
  return convertDatesAtPathsJson2Js(IMPORT_DATES_PATHS)(importForm);
}
export function convertDatesImportJs2Json(importForm) {
  return convertDatesAtPathsJs2Json(IMPORT_DATES_PATHS)(importForm);
}

/**
 * Import form schema.
 */
export const importSchema: RecordSchema = makeRegistrationSchema({
  intermediaryVat: stringSchema(),

  currVatId: recordSchema({
    issuingCountry: stringSchema(),
    vatIdNum: stringSchema(),
  }),

  identificationOfBusiness: vatIdSchema(IDENTIFICATION_OF_BUSINESS_VAT_ID_VALIDATOR, true),

  bankAccountInfo: bankAccountInfoSchema(false, true),

  fixedEstablishments: fixedEstablishmentsSchema(true),

  changePlaceOfBusiness: booleanSchema({isClientOnly: true}),

}, OssSchemaType.IMPORT, [
  ctx => {
    if (registeredByNetp(getInitialValues(ctx))) {
      if (ctx.get('./bankAccountInfo') == null) {
        return {code: IS_REQUIRED_CODE};
      }
    } else {
      if (ctx.get('./bankAccountInfo') != null) {
        return {code: CustomErrorCodes.BANK_ACCOUNT_INFO_NOT_ALLOWED.code };
      }
    }
  },
  ctx => {
    return IdentOfBusinessValidator.validateEqualCountryAndIssuer(ctx.get('./countryOfBusiness'), ctx.get('./cobRegion'), ctx.get('./identificationOfBusiness/issuingCountry'), true) ?? undefined;
  },
  ctx => {
    return IdentOfBusinessValidator.validateIssuerNotXiXu(ctx.get('./identificationOfBusiness/issuingCountry'), ctx.get('./identificationOfBusiness/vatIdNum')) ?? undefined;
  },
  ctx => {
    return IdentOfBusinessValidator.validateNatTaxRefMandatoryIssuer(ctx.get('./cobRegion'), ctx.get('./identificationOfBusiness/issuingCountry')) ?? undefined
  }
]);
